import { createApi } from '../lib/api.js';
import {
	escapeHtml,
	buildBookingUrl,
	getInitials,
} from '../lib/utils.js';

export function initStaffSelector(root, cfg) {
	const api = createApi(cfg);
	const serviceId = parseInt(root.getAttribute('data-service-id') || '0', 10);
	const bookingUrl = (cfg.bookingPageUrl || '').trim();
	const hasBookingUrl = bookingUrl.length > 0;

	if (!serviceId) {
		root.innerHTML =
			'<p class="bookpress-error">Missing service. Set data-service-id on this widget.</p>';
		return;
	}

	if (!hasBookingUrl) {
		console.warn(
			'[BookPress] bookingPageUrl is not set. Staff Select buttons are disabled.'
		);
	}

	root.innerHTML = '<p class="bookpress-loading">Loading staff…</p>';

	api
		.get('/services/' + serviceId + '/staff')
		.then((staffList) => {
			const list = staffList || [];

			if (!list.length) {
				root.innerHTML =
					'<p class="bookpress-empty">No staff available for this service.</p>';
				return;
			}

			const cards = list
				.map((member) => {
					const initials = getInitials(member.full_name);
					const avatar = member.photo
						? '<img class="bookpress-staff-card__photo" src="' +
							escapeHtml(member.photo) +
							'" alt="" loading="lazy" />'
						: '<div class="bookpress-staff-card__avatar" aria-hidden="true">' +
							escapeHtml(initials) +
							'</div>';

					const services = member.services || [];
					const tags = services.length
						? '<div class="bookpress-staff-card__tags">' +
							services
								.map(
									(s) =>
										'<span class="bookpress-tag">' +
										escapeHtml(s.name) +
										'</span>'
								)
								.join('') +
							'</div>'
						: '';

					const selectDisabled = hasBookingUrl ? '' : ' disabled';

					return (
						'<article class="bookpress-staff-card">' +
						avatar +
						'<div class="bookpress-staff-card__body">' +
						'<h3 class="bookpress-staff-card__name">' +
						escapeHtml(member.full_name) +
						'</h3>' +
						(member.role_title
							? '<p class="bookpress-staff-card__role">' +
								escapeHtml(member.role_title) +
								'</p>'
							: '') +
						tags +
						'<button type="button" class="bookpress-btn bookpress-btn--primary bookpress-staff-card__select" data-staff-id="' +
						escapeHtml(String(member.id)) +
						'"' +
						selectDisabled +
						'>Select</button>' +
						'</div></article>'
					);
				})
				.join('');

			root.innerHTML =
				'<div class="bookpress-staff-grid">' + cards + '</div>';

			root.querySelectorAll('.bookpress-staff-card__select').forEach((btn) => {
				btn.addEventListener('click', () => {
					if (!hasBookingUrl) {
						return;
					}
					const staffId = btn.getAttribute('data-staff-id');
					window.location.href = buildBookingUrl(bookingUrl, {
						service_id: serviceId,
						staff_id: staffId,
						bookpress_service: serviceId,
					});
				});
			});
		})
		.catch((err) => {
			root.innerHTML =
				'<p class="bookpress-error">' + escapeHtml(err.message) + '</p>';
		});
}
